export default "/images/designed-hover.svg?c88eff62d89ec8b07cb31b18aa9ecfd3";